/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量14
 * @export
 * @interface Col14
 */
export interface Col14 {
}

/**
 * Check if a given object implements the Col14 interface.
 */
export function instanceOfCol14(value: object): value is Col14 {
    return true;
}

export function Col14FromJSON(json: any): Col14 {
    return Col14FromJSONTyped(json, false);
}

export function Col14FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col14 {
    return json;
}

export function Col14ToJSON(json: any): Col14 {
    return Col14ToJSONTyped(json, false);
}

export function Col14ToJSONTyped(value?: Col14 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

